import moment from "moment";
import { Box, Divider, HStack, Text, VStack, useBreakpointValue } from "native-base";
import React, { useEffect, useRef } from "react";
import { ScrollView } from "react-native";

import Container from "@/components/organisms/Container";
import { useViewport } from "@/contexts/ViewportContext";

import { OrdeEvaluationScreenProps } from "../types";
import AppEvaluationStep from "./AppEvaluationStep";
import DeliveryEvaluationStep from "./DeliveryEvaluationStep";
import OrderEvaluationStepper from "./OrderEvaluationStepper";
import StoreEvaluationStep from "./StoreEvaluationStep";

const OrderEvaluationContainer = ({
  currentStep,
  order,
  isSubmiting,
  onCancel,
  onSubmitAppEvaluation,
  onSubmitDeliveryEvaluation,
  onSubmitStoreEvaluation,
}: Omit<OrdeEvaluationScreenProps, "isLoading" | "onGoBack">) => {
  const scrollViewRef = useRef<ScrollView>();

  const responsiveWidth = useBreakpointValue({
    base: 2,
    xl: 2.5,
    "2xl": 3.5,
  });

  const { width: windowWidth, isWebMode } = useViewport();
  const width = isWebMode ? windowWidth / responsiveWidth : windowWidth;
  const maxWidth = width * 3;

  useEffect(() => {
    scrollViewRef.current?.scrollTo({
      x: width * currentStep,
      animated: true,
    });
  }, [currentStep]);
  return (
    <>
      <Box px="4">
        <HStack py="2" space="4" alignItems="center">
          <Box borderColor="primary.600" borderWidth={1} rounded="md" p="1">
            <Text fontSize="md" bold>
              {moment(order.agendado ? order.dataAgendamento : order.createdAt).format(
                "DD/MM/YYYY"
              )}
            </Text>
          </Box>
          <VStack flex={1}>
            <Text fontSize="lg" bold flexWrap="wrap">
              {order?.estabelecimento?.nome_fantasia}
            </Text>
            <Text>{order.codigo}</Text>
          </VStack>
        </HStack>
        <Divider my="2" />
        <OrderEvaluationStepper activeIndex={currentStep} />
      </Box>
      <Box alignItems="center">
        <ScrollView
          ref={scrollViewRef}
          horizontal
          showsHorizontalScrollIndicator={false}
          scrollEnabled={false}
          style={{ width, maxWidth }}>
          <Container p="0" px={isWebMode ? 1 : 4} width={width}>
            <StoreEvaluationStep onSubmit={onSubmitStoreEvaluation} onCancel={onCancel} />
          </Container>
          <Container p="0" px={isWebMode ? 1 : 4} width={width}>
            <DeliveryEvaluationStep onSubmit={onSubmitDeliveryEvaluation} onCancel={onCancel} />
          </Container>
          <Container p="0" px={isWebMode ? 1 : 4} width={width}>
            <AppEvaluationStep
              onSubmit={onSubmitAppEvaluation}
              onCancel={onCancel}
              isSubmiting={isSubmiting}
            />
          </Container>
        </ScrollView>
      </Box>
    </>
  );
};

export default OrderEvaluationContainer;
